import { pipe } from 'ramda';

import { fetchValue } from './util';

export default pipe(
  fetchValue,
  (string) => !string.startsWith(' ') && !string.endsWith(' ')
);
